import { render, staticRenderFns } from "./MaterialIcon.vue?vue&type=template&id=1047ecc4&"
import script from "./MaterialIcon.vue?vue&type=script&lang=js&"
export * from "./MaterialIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports